import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  EventService,
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
  WindowRef,
} from '@spartacus/core';
import {
  CurrentProductService,
  ProductIntroComponent,
} from '@spartacus/storefront';
import { ProductService } from '../service/product.service';

@Component({
  selector: 'app-product-card-information',
  templateUrl: './product-card-information.component.html',
  styleUrls: ['./product-card-information.component.scss'],
})
export class ProductCardInformationComponent
  extends ProductIntroComponent
  implements OnInit, OnDestroy
{
  public productCode: any;
  public productApiResult: any;
  public _translationService: TranslationService;
  productImages: any;
  constructor(
    protected currentProductService: CurrentProductService,
    translationService: TranslationService,
    protected winRef: WindowRef,
    protected eventService: EventService,
    protected productService: ProductService,
    private globalMessageService: GlobalMessageService,
    protected cd: ChangeDetectorRef
  ) {
    super(currentProductService, translationService, winRef);
    this._translationService = translationService;
  }

  ngOnInit(): void {
    this._translationService
      .translate('formErrors.globalMsg')
      .subscribe((data) => {
        if (data) {
          this.globalMessageService.add(
            data ?? '',
            GlobalMessageType.MSG_TYPE_INFO,
            600000
          );
          this.cd.detectChanges();
        }
      });
    this.currentProductService.getProduct().subscribe((resp) => {
      this.productImages = resp?.images;
      if (!this.productImages) {
        document.body.classList.add('expand-image-hide');
      } else {
        document.body.classList.remove('expand-image-hide');
      }
      this.productCode = resp?.code;
      this.productService.productCode.next(resp?.code);
      if (this.productCode) {
        this.productService
          .getProductsDetails(this.productCode)
          .subscribe((resp) => {
            this.productService.pdpDetails.next(resp);
            this.productApiResult = resp;
            this.cd.detectChanges();
          });
      }
      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
  }
}
